
import {
    EXPERT_ARTICLES_RESPONSE,
    EXPERT_ARTICLES_FAILURE,
    EXPERT_ARTICLES_MORE_REQUEST,
    EXPERT_ARTICLES_MORE_FAILURE,
    EXPERT_ARTICLES_MORE_RESPONSE,
    CLEAR_EXPERT_BIO_RESULTS
 } from '../../actions/types';
 
 const initialState = {
    isFetching: true,
    articles: [],
    error: false,
    from: 0,
    size: 10,
    isMoreResult: true,
    isMoreResultFetching: false,
    totalArticles: 0,
    activePage: 1,
    sort: "citation"
 };
 

const setFailure = (state, action) => {
    
    return {
        ...state,
        isFetching: false,
        error: true,
        articles: [],
    }
}

const setResults = (state, action) => {
    
    let articles = action.payload.articles || [];
    let totalArticles = action.payload.totalArticles || 0;
    let sort = action.payload.sort || "citation";

    let isMoreResult = true;
    let size = state.size;

    if(articles.length < size){
        isMoreResult =false
    }
    return {
        ...state,
        isFetching: false,
        error: false,
        articles,
        isMoreResult,
        totalArticles,
        sort
    }
    
}


const setMoreResultResponse = (state, action) => {

    let articles = action.payload.articles|| [];
    let isMoreResult = true;
  
    if(articles.length == 0){
       isMoreResult = false;
    }

  
    return {
      ...state,
      articles,
      isMoreResult,
      isMoreResultFetching: false,
    }
  
  }
  
  const setMoreResultRequest = (state, action) => {
       
       let from = action.payload.from || 0;
       let selectedPage = action.payload.selectedPage || 1;
       let sort = action.payload.sort || "citation";

       return {
         ...state,
         isMoreResultFetching: true,
         from,
         activePage: selectedPage,
         sort: sort
       }
  }
  
  const setMoreResultFailure = (state, action) => {
    return {
      ...state,
      isMoreResultFetching: false,
    }
  }

 
 export default (state = initialState, action) => {
     switch (action.type) {
        case EXPERT_ARTICLES_RESPONSE:
             return setResults(state,action);
             break;
         
        case EXPERT_ARTICLES_FAILURE:
             return setFailure(state,action);
             break;
        
        case EXPERT_ARTICLES_MORE_REQUEST:
             return setMoreResultRequest(state, action);
        
        case EXPERT_ARTICLES_MORE_FAILURE:
             return setMoreResultFailure(state, action);
             
        case EXPERT_ARTICLES_MORE_RESPONSE:
             return setMoreResultResponse(state, action);
        
        case CLEAR_EXPERT_BIO_RESULTS:
            return initialState;
             
        default:
             return state;
             break;
     }
 }